<div>
  <div class="info-header">
    <div class="container-fluid lh-container-fluid">
      <div class="flex" *ngIf="selectedShop">
        <div class="heading-5">
          <a class="breadcrumb-link" [routerLink]="'/dashboard'">{{ selectedShop.name }}</a>
          <span class="breadcrumb-divider">></span>{{ 'BILLING' | translate }}
        </div>

        <!-- <div class="filter">
          <div class="btn-group">
            <button
              id="showPayouts"
              (click)="showPayouts()"
              class="btn btn-primary tab"
              [class.active]="activeTab === 'payouts'"
            >
              {{ 'PAYOUTS' | translate }}
            </button>
            <button
              id="showPayments"
              (click)="showPayments()"
              class="btn btn-primary tab"
              [class.active]="activeTab === 'payments'"
            >
              {{ 'PAYMENTS' | translate }}
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="container-fluid lh-container-fluid">
    <div class="row">
      <!--Transaction filters-->
      <div class="col-md-12 mb-2">
        <kendo-datepicker class="datepicker" [(ngModel)]="from" [min]="minDate" [max]="maxDate"></kendo-datepicker>

        <svg
          class="arrow"
          width="131px"
          height="41px"
          viewBox="462 225 131 41"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M561.5,243 L463,243 L463,249 L561.5,249 L561.5,265.5 L584.5,245.5 L561.5,225.5 L561.5,243 Z"
            id="Combined-Shape"
            stroke="none"
            fill="#000000"
            fill-rule="nonzero"
          ></path>
        </svg>

        <kendo-datepicker class="datepicker" [min]="minDate" [max]="maxDate" [(ngModel)]="to"></kendo-datepicker>

        <button
          id="applyTransactionFilters"
          type="button"
          [disabled]="from > to || isLoading"
          class="btn btn-default apply"
          (click)="applyFilters()"
        >
          {{ 'APPLY' | translate }}
        </button>

        <span *ngIf="from > to">{{ 'INVALID_PERIOD' | translate }}</span>
      </div>

      <!--Transactions-->
      <div class="col-md-12">
        <kendo-grid [kendoGridBinding]="visibleTransactions" [sortable]="true" [scrollable]="true">
          <kendo-grid-messages [noRecords]="(isLoading ? 'LOADING' : 'NO_TRANSACTIONS') | translate">
          </kendo-grid-messages>

          <ng-template kendoGridToolbarTemplate>
            <button id="exportTransactionsToExcel" type="button" kendoGridExcelCommand>
              <span class="k-icon k-i-file-excel"></span>{{ 'EXPORT_TO_EXCEL' | translate }}
            </button>
          </ng-template>

          <kendo-grid-column [title]="'DATE' | translate" [style]="{ 'text-align': 'right' }" width="100">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.date | lhMoment: 'localeDate' }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="id" [title]="'TRANSACTION_REFERENCE' | translate" width="175"></kendo-grid-column>

          <kendo-grid-column [title]="'DESCRIPTION' | translate" width="200">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <span>{{ dataItem.text }}</span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [title]="'AMOUNT' | translate" [style]="{ 'text-align': 'right' }" width="100">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ dataItem.amount | price: dataItem.currency : 2 : false }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column *ngIf="activeTab === 'payouts'" [title]="'INVOICE' | translate" width="200">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <div *ngIf="dataItem.type === 1">
                <button id="showInvoice" class="btn btn-info invoice" (click)="showInvoice(dataItem.value)">
                  {{ 'VIEW' | translate }}
                </button>
                <button id="downloadInvoice" class="btn btn-info invoice" (click)="downloadInvoice(dataItem.value)">
                  {{ 'DOWNLOAD' | translate }}
                </button>
              </div>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-excel fileName="Transactions.xlsx">
            <kendo-excelexport-column field="date" title="Date" width="100"></kendo-excelexport-column>
            <kendo-excelexport-column field="id" title="Reference" width="130"></kendo-excelexport-column>
            <kendo-excelexport-column field="text" title="Description" width="300"></kendo-excelexport-column>
            <kendo-excelexport-column field="amount" title="Amount" width="80"></kendo-excelexport-column>
            <kendo-excelexport-column field="currency" title="Currency" width="80"></kendo-excelexport-column>
          </kendo-grid-excel>
        </kendo-grid>

        <!-- Footer with totals -->
        <div class="footer">
          <h4 class="heading-4">
            <span *ngIf="activeTab === 'payments'">{{ totalIncome | price: selectedCurrency : 2 : false }}</span>
            <span *ngIf="activeTab === 'payouts'">{{ totalTransferred | price: selectedCurrency : 2 : false }}</span>
          </h4>
          <small class="estimated">
            <span *ngIf="activeTab === 'payments'">{{ 'SHOP_TOTAL_REVENUE' | translate }}</span>
            <span *ngIf="activeTab === 'payouts'">{{ 'SHOP_TOTAL_PAYOUTS' | translate }}</span>
          </small>
        </div>
      </div>
    </div>
  </div>
</div>
